import {
  UPDATE_PARTNER_SITE,
  UPDATE_SEGMENT,
  UPDATE_LINE,
  UPDATE_PARTNER_NAME,
  UPDATE_ODM,
  UPDATE_CUSTOMER_CLASS,
  UPDATE_PARTNER_SITE_LIST,
  UPDATE_SEGMENT_LIST,
  UPDATE_LINE_LIST,
  FETCH_PARTNER_SITES_START,
  FETCH_PARTNER_SITES_SUCCESS,
  FETCH_PARTNER_SITES_ERROR,
  UPDATE_AE_REGION,
  UPDATE_AE_REGION_LIST,

} from './constants'
import { createReducer } from 'helpers/ReducerUtil'
import { combineReducers } from 'redux'

const updatePartnerSiteList = (prev, { list }) => list.map(site => ({ value: site, label: site }))
const updatePartnerSite = (prev, { site }) => site
const updateSegment = (prev, { seg }) => seg
const updateLine = (prev, { line }) => line
const updatePartnerName = (prev, { name }) => name
const updateOdm = (prev, { odm }) => odm
const updateCustomerClass = (prev, { customerClass }) => customerClass
const updateAeRegion = (prev, { aeRegion }) => aeRegion
const updateSegmentList = (prev, { segments }) => segments.map(seg => ({ value: seg, label: seg }))
const updateLineList = (prev, { lines }) => lines.map(line => ({ value: line, label: line }))
const updateAeRegionList = (prev, { aeRegions }) => aeRegions.map(aeRegion => ({ value: aeRegion, label: aeRegion }))
const updateIsPartnerSiteLoading = (prev, { isLoading }) => isLoading

const partnerSiteListReducer = createReducer([], {
  [UPDATE_PARTNER_SITE_LIST]: updatePartnerSiteList
})

const partnerSiteReducer = createReducer('', {
  [UPDATE_PARTNER_SITE]: updatePartnerSite
})

const segmentReducer = createReducer([], {
  [UPDATE_SEGMENT]: updateSegment
})

const lineReducer = createReducer([], {
  [UPDATE_LINE]: updateLine
})

const partnerNameReducer = createReducer('', {
  [UPDATE_PARTNER_NAME]: updatePartnerName
})

const odmReducer = createReducer('', {
  [UPDATE_ODM]: updateOdm
})

const customerClassReducer = createReducer ('', {
  [UPDATE_CUSTOMER_CLASS]: updateCustomerClass
})

const segmentListReducer = createReducer([], {
  [UPDATE_SEGMENT_LIST]: updateSegmentList
})

const lineListReducer = createReducer([], {
  [UPDATE_LINE_LIST]: updateLineList
})

const isPartnerSiteLoadingReducer = createReducer(false, {
  [FETCH_PARTNER_SITES_START]: updateIsPartnerSiteLoading,
  [FETCH_PARTNER_SITES_SUCCESS]: updateIsPartnerSiteLoading,
  [FETCH_PARTNER_SITES_ERROR]: updateIsPartnerSiteLoading
})

const aeRegionReducer = createReducer('', {
  [UPDATE_AE_REGION]: updateAeRegion
})

const aeRegionListReducer = createReducer([], {
  [UPDATE_AE_REGION_LIST]: updateAeRegionList
})

export default combineReducers({
  partnerSiteList: partnerSiteListReducer,
  partnerSite: partnerSiteReducer,
  segment: segmentReducer,
  line: lineReducer,
  partnerName: partnerNameReducer,
  odm: odmReducer,
  customerClass: customerClassReducer,
  aeRegion: aeRegionReducer,
  aeRegionList: aeRegionListReducer,
  segmentList: segmentListReducer,
  lineList: lineListReducer,
  isPartnerSiteLoading: isPartnerSiteLoadingReducer
})
